import { Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';

interface Props {
  label: string;
  children: ReactNode;
}

export const ResultRow = ({ label, children }: Props) => (
  <Stack
    direction="row"
    alignItems="center"
    justifyContent="space-between"
    px={2}
    py={1.5}
    borderRadius={2}
    border={({ palette }) => `1px solid ${palette.divider}`}
  >
    <Typography variant="body2">{label}</Typography>
    <Typography variant="subtitle2" component="div">
      {children}
    </Typography>
  </Stack>
);
